import { FC, useMemo } from 'react'
import Linkify from 'linkify-react'
import type { Opts } from 'linkifyjs'

import { toSafeHttpUrl } from 'features/space/lib/toSafeHttpUrl'

import styles from './SafeLinkifiedText.module.scss'

type Props = {
  children: string
}

const createLinkifyOptions = (text: string): Opts => ({
  className: { url: styles.link },
  defaultProtocol: 'https',
  formatHref: (value, type) => (type === 'url' ? toSafeHttpUrl(value) ?? value : value),
  rel: { url: 'noopener noreferrer' },
  target: { url: '_blank' },
  validate: (value, type, token) => {
    if (type !== 'url' || toSafeHttpUrl(value) === null) return false

    return text[token.startIndex() - 1] !== '@' && text[token.endIndex()] !== '@'
  },
})

export const SafeLinkifiedText: FC<Props> = ({ children }) => {
  const options = useMemo(() => createLinkifyOptions(children), [children])

  return (
    <Linkify as="span" options={options}>
      {children}
    </Linkify>
  )
}
